export default "__VITE_ASSET__5cb7bafb__"